import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface AddressPAF {
  POBox: string;
  buildingName: string;
  buildingNumber: string;
  departmentName: string;
  dependentLocality: string;
  dependentThoroughfare: string;
  doubleDependentLocality: string;
  organisationName: string;
  postcode: string;
  subBuildingName: string;
  thoroughfare: string;
  town: string;
}

@Injectable({
  providedIn: 'root'
})
export class AddressFinderService {

  constructor(
    private http: HttpClient,
  ) { }

  getFromPostcode(postcode: string): Observable<AddressPAF[]> {
    postcode = postcode.replace(/\s/g, '');
    return this.http.get<any>(`${environment.apiUrl}/api/addresses/match/${postcode}`);
  }

  getAddressLines(address: AddressPAF): string[] {
    // PO Box address without a name (PO Box 22, Fareham, PO14 3XH )
    if (address.POBox) {
      return [
        `PO Box ${address.POBox}`
      ];
    }

    // Typical organisation address (Kath's cakes, Victoria house, High street, Portsmouth, PO1 1AF)
    if (address.organisationName) {
      return [
        `${address.organisationName} ${address.buildingName}`,
        `${address.thoroughfare}`
      ];
    }

    // Typical residential address (16 Vixen road, Bradock, KT6 5BT)

    // The residential premises elements of a PAF address are: Sub Building Name, Building Name, Building Number
    // A combination of these elements may be present, but a Sub Building Name cannot be present on its own.
    // When a Sub Building is present, there will always be Building Name or Building Number data present.
    if (address.subBuildingName) {
      return [
        `${address.subBuildingName}${address.buildingName ? ', ' + address.buildingName : ''}`,
        `${address.buildingNumber ? address.buildingNumber + ', ' : ''}${address.thoroughfare}`
      ];
    }

    if (address.dependentThoroughfare) {
      return [
        `${address.buildingName ? address.buildingName + ', ' : ''}${address.dependentThoroughfare}`,
        `${address.buildingNumber ? address.buildingNumber + ', ' : ''}${address.thoroughfare}`
      ];
    }

    if (address.buildingName) {
      return [
        `${address.buildingName}`,
        `${address.buildingNumber ? address.buildingNumber + ', ' : ''}${address.thoroughfare}`
      ];
    }

    return [
      `${address.buildingNumber ? address.buildingNumber + ', ' : '' }${address.thoroughfare}`
    ];
  }
}
